module.exports = __webpack_public_path__ + "img/slack.48a3232b.svg";